@if (configTable) {
<table class="table is-striped is-hoverable">
    <thead>
        <tr>
            @for (header of configTable.headers; track header.key) {
                <th>{{header.name}}</th>
            }
        </tr>
    </thead>
    <tbody>
        @for (item of configTable.data; track item.id; let index = $index) {
        <tr class="is-clickable" (click)="goToDetail(item.id)">
            @for (header of configTable.headers; track header.key) {
                @if (header.key === 'isActive') {
                <td>
                    @if(item[header.key]) {
                        <span class="tag active"><fa-icon [icon]="faCircle"></fa-icon>Activo</span>
                    } @else {
                        <span class="tag inactive"><fa-icon [icon]="faCircle"></fa-icon>Inactivo</span>
                    }
                </td>
                } @else if (header.key === 'name') {
                <td>
                  <div class="user-cell">
                    <span class="avatar" aria-hidden="true">{{ getInitials(item.name) }}</span>
                    {{ item.name || '-' }}
                  </div>
                </td>
                } @else if (header.key === 'department') {
                <td>{{ getDepartmentLabel(item[header.key]) }}</td>
                } @else if (header.key === 'roles') {
                <td>
                  <div class="role-tags">
                    @for (role of item['roles']; track role) {
                      <span class="role-tag selected">{{ getRolLabel(role) }}</span>
                    }
                  </div>
                </td>
                } @else {
                <td>{{ item[header.key] || '-' }}</td>
                }
            }
        </tr>
        } @empty {
        <tr>
            <td [attr.colspan]="configTable.headers.length" class="empty-row" >
                @if (hasFilters) {
                  <p>No hay usuarios con estos filtros</p>
                  <button type="button" class="button is-outlined clear-filters" (click)="clearFilters.emit(); $event.stopPropagation()">Limpiar filtros</button>
                } @else {
                  No hay usuarios
                }
            </td>
        </tr>
        }
    </tbody>
</table>
}
